/* Built In Imports */
import Head from 'next/head';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import RenderSections from '@ieo/Common/RenderSections';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import { ProgramLanguageSelectionProvider } from '@ieo/Components/Form/ieo/context/programLanguageSelectionContext';
import { useFormImpression } from '@utils/globalMixpanelEvents';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
  getCurrentRegion,
} from 'services/commonService';
import {
  fetchDetailsIeopc,
  fetchIEOPrgData,
  fetchIEOSupportData,
  getLandingPaths,
} from 'services/ieoService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Inner Engineering Online Landing page Data
 */
const InnerEngineering = ({ region, language, pageData, pageName }) => {
  const [programData, setProgramData] = useState('');
  const [supportData, setSupportData] = useState('');

  const searchParams = useSearchParams();
  const router = useRouter();

  // Use the mixpanel registration form impression with the fromId
  useFormImpression('ieo-enroll-section');

  useEffect(() => {
    localData();
  }, [pageData]);

  // console.log('pageData', pageData);

  const localData = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const reg = await getCurrentRegion(urlParams.get('country'));
    if (reg?.country) {
      pageData.country = reg.country;
      const ieoPrgList = await fetchIEOPrgData(reg.country);
      setProgramData(ieoPrgList?.data);

      const supData = await fetchIEOSupportData(reg.country, language);
      setSupportData(supData?.data);
    }
  };

  return (
    <ProgramLanguageSelectionProvider>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>

      {region == 'in' && (
        <Head>
          <link
            rel="preconnect"
            href="https://dev.visualwebsiteoptimizer.com"
          />

          <script
            dangerouslySetInnerHTML={{
              __html: `
            window._vwo_code || (function() {
            var account_id=872818,
            version=2.1,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var i=this.getSettings(),n=d.createElement('script'),r=this;t=t||{};if(i){n.textContent=i;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200){w._vwo_code.addScript({text:o.responseText})}else{w._vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}w._vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var i=this.hide_element(),n=i?i+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=n;else t.appendChild(d.createTextNode(n));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var n=d.createElement('div');n.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;';n.setAttribute('id','_vis_opt_path_hides');n.classList.add('_vis_hide_layer');t.parentNode.insertBefore(n,t.nextSibling)}var o='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:o})}else{this.load(o+'&x=true')}}};w._vwo_code=code;code.init();})();(function(){var i=window;function t(){if(i._vwo_code){var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){if(!document.getElementById('_vis_opt_path_hides')){document.getElementsByTagName('head')[0].appendChild(e)}requestAnimationFrame(t)}}}t()})();
            `,
            }}
          />
        </Head>
      )}
      <WrapLayout pageData={pageData}>
        <HeadComponent
          data={pageData?._seoMetaTags || pageData?.seoFields}
          availableLocals={pageData?.availableLocales}
        >
          {' '}
        </HeadComponent>
        <Box as="section" p="0" maxW="1920px" w="100%" m="0 auto">
          {pageData?.body?.length &&
            pageData.body[0]?.value?.map((section, index) => {
              return (
                <RenderSections
                  pageData={pageData}
                  section={section}
                  region={region}
                  lang={language}
                  key={index}
                  // This was causing all components to clear state on render
                  // key={nanoid(4)}
                  csrData={programData}
                  pageName={pageName}
                  supportData={supportData}
                />
              );
            })}
        </Box>
      </WrapLayout>

      <script
        dangerouslySetInnerHTML={{
          __html: `(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,324804,344111);`,
        }}
      />

      <script
        dangerouslySetInnerHTML={{
          __html: `(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,324804,'u8welaoz8o8bcqac8osu');`,
        }}
      />
    </ProgramLanguageSelectionProvider>
  );
};

export const getStaticPaths = async () => {
  const ieoLandingPaths = config.USE_LOCAL_URL
    ? [
        '/in/en/inner-engineering-pc',
        '/ca/en/inner-engineering-pc',
        '/us/en/inner-engineering-pc',
        '/sg/en/inner-engineering-pc',
        '/au/en/inner-engineering-pc',
        '/uk/en/inner-engineering-pc',
        '/my/en/inner-engineering-pc',
        '/global/en/inner-engineering-pc',
      ]
    : await getLandingPaths('lvl0', '/inner-engineering-pc', [
        '/inner-engineering-pc-2',
        '/inner-engineering-pc-3',
        '/inner-engineering-pc-4',
      ]);
  return {
    paths: ieoLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetailsIeopc(region, language, '', {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      hideTopMenu: true,
      showHeader: false,
      pageName: 'ieopaidcampgn',
    },
  };
};

export default InnerEngineering;
